// Places a peer's moves on our clock by when they were SENT (`ts`, the sender's performance.now()), so the
// interpolation between them runs at the speed they really moved — arrival times carry the network's jitter,
// and a car at 500 px/s turned every 30 ms of it into a 15 px lurch (owner 2026-11-02: "when someone is
// driving me it's quite laggy").
//
// Our clock minus theirs is learnt as the smallest (arrival - ts) seen — the quickest delivery — so a move is
// placed at the time it would have arrived with no hold-up, never later than it did. That minimum creeps up
// by DRIFT ms per ms, so a delay that grows for good (another route, a busier server) is followed within
// seconds instead of leaving every move late. A jump of more than RESET_MS means the sender's clock started
// over (they reloaded the page): follow it at once. Moves without a ts (older clients, NPCs) keep their arrival.
const DRIFT = 0.005;
const RESET_MS = 1000;

export function createPacketClock() {
  let offset = null;
  let lastArrival = 0;
  let lastT = -Infinity;
  return (arrival, ts) => {
    let t;
    if (!Number.isFinite(ts)) {
      t = arrival;
    } else {
      const sample = arrival - ts;
      if (offset === null || sample - offset > RESET_MS) offset = sample;
      else offset = Math.min(sample, offset + (arrival - lastArrival) * DRIFT);
      t = ts + offset;
    }
    lastArrival = arrival;
    t = Math.max(t, lastT + 1);   // a stale resend still lands after what we already have
    lastT = t;
    return t;
  };
}
